import React from "react";
import { Row, Col } from "antd";
import { Statistic, Card } from "antd";

import Countdown from "antd/lib/statistic/Countdown";
import Axios, { AxiosResponse, AxiosError } from "axios";
import "./Dashboard.css";

type DashboardItem = {
  title: string,
  value: string
};

type State = {
  dashboardItems: DashboardItem[],
  timerId?: Object
};

const DASHBAORD_API = "/api/webapp/dashboard";

export default class Dashboard extends React.PureComponent<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = { dashboardItems: [] };
  }
  onResponse = (response: AxiosResponse) => {
    if (response.status === 200) {
      const dashboardItems: DashboardItem[] = response.data["entries"];
      this.setState({ dashboardItems: dashboardItems });
      clearTimeout(this.state.timerId);
      this.setState({ timerId: setTimeout(this.fetch, 3000) });
    } else {
      alert(response.data);
    }
  };

  onError = (error: AxiosError) => {
    console.log(error);
    alert(error);
  };
  componentDidMount() {
    this.fetch();
  }

  fetch = () => {
    Axios.get(DASHBAORD_API + "?_d" + Date.now())
      .then(this.onResponse)
      .catch(this.onError);
  };

  componentWillUnmount() {
    clearTimeout(this.state.timerId);
  }

  render() {
    const cards = [];
    if (this.state.dashboardItems) {
      for (let index = 0; index < this.state.dashboardItems.length; index++) {
        const dashboardItem: DashboardItem = this.state.dashboardItems[index];
        const stats = (
          <Col span={8}>
            <Card className= "card-layout" >
              <Statistic
                title={dashboardItem.title}
                value={dashboardItem.value.replace("\n", "<br>")}
              />
            </Card>
          </Col>
        );
        cards.push(stats);
      }
    }
    return (
      <div style={{ background: "unset", padding: "30px" }}>
        <Row gutter={16} style={{ marginTop: "15px" }}>
          {cards}
        </Row>
      </div>
    );
  }
}
